import { render, staticRenderFns } from "./Well.vue?vue&type=template&id=44838893&scoped=true"
var script = {}
import style0 from "./Well.vue?vue&type=style&index=0&id=44838893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44838893",
  null
  
)

export default component.exports